module.exports = __webpack_public_path__ + "img/Ptuapp8.8f72faa7.png";